import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { TellUsButton } from "@/components/common/TellUsButton";
import { useHeaderState } from "@/hooks/useHeaderState";
import { DesktopNav, MobileNav } from "./HeaderNav";
import { cn } from "@/lib/utils";

const Logo = () => (
  <Link to="/" className="group flex items-center" data-testid="logo-home-link">
    <img
      src="/success-crest-logo.png"
      alt="Success Crest Consulting"
      className="h-12 w-auto object-contain"
    />
  </Link>
);

export const Header = () => {
  const { pathname } = useLocation();
  const header = useHeaderState(pathname);
  return (
    <header className={cn("fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300",
      header.scrolled ? "border-b border-black/5 bg-white/70 backdrop-blur-xl" : "border-b border-transparent bg-transparent")} data-testid="site-header">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 lg:px-8">
        <Logo dark={header.dark} />
        <DesktopNav dark={header.dark} megaOpen={header.megaOpen} setMegaOpen={header.setMegaOpen} />
        <div className="hidden lg:block"><TellUsButton size="sm" testId="header-tell-us-cta" /></div>
        <button className={cn("flex h-10 w-10 items-center justify-center rounded-xl border lg:hidden",
          header.dark ? "border-white/20 text-white" : "border-border bg-white text-slate-800")}
          onClick={header.toggleMobile} aria-label="Toggle menu" aria-expanded={header.mobileOpen} data-testid="mobile-menu-toggle">
          {header.mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      <MobileNav open={header.mobileOpen} onNavigate={header.closeMobile} />
    </header>
  );
};
